import { Component, OnInit, inject, input } from '@angular/core';
import { InstallAppService } from '../../../services/install-app.service';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { RouterLinkDirective } from '../../directives/router-link.directive';
import { RouterLink } from '@angular/router';
import { BtnComponent } from '../btn/btn.component';

export enum InstallBannerPlace {
  HOME = 'home',
  LOGIN = 'login'
}

@Component({
    selector: 'app-install-app-banner',
    templateUrl: './install-app-banner.component.html',
    styleUrls: ['./install-app-banner.component.scss'],
    imports: [BtnComponent, RouterLink, RouterLinkDirective, TranslatePipe]
})
export class InstallAppBannerComponent implements OnInit {
  installApp = inject(InstallAppService);


  readonly place = input<InstallBannerPlace>(InstallBannerPlace.HOME);

  ngOnInit() {
  }


  public closeBanner() {
    if (this.place() === InstallBannerPlace.HOME) {
      this.installApp.closeDepositBlock();
    } else {
      this.installApp.closeRegisterBlock();
    }
  }

}
